import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
    Container,
    Row,
    Col
} from "reactstrap";


//Import Images
import homeImg from "../../assets/images/home-img.png";


class Section extends Component {

    render() {
        return (
            <React.Fragment>
                <section className="hero-section" id="home">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6}>
                                <div className="hero-wrapper mb-4 pb-20 ">
                                    <p className="font-22 text-uppercase">Discover Flexsu Today</p>
                                    <h1 className="hero-title font-45 mb-4">Secure. Scale. Monitor.</h1>
                                    <p className="font-22">Helping <strong>crypto</strong> dev teams bring their projects to next level. Blockchain <strong>security</strong> , Smart contracts <strong>audits</strong>, On-chain and Off-chain <strong>monitoring</strong>, and so on.</p>
                                    <div className="mt-4 mb-4">
                                        {/* <Link to="#" className="btn btn-primary mt-2 mr-2">Get Started</Link> */}
                                        <Link to={{  pathname: `${process.env.REACT_APP_CALL_CALENDAR_URL}` }} target="_blank" className="btn btn-success mt-2 mr-2 ml-1">Schedule a call</Link>
                                        
                                    </div>
                                </div>
                            </Col>

                            <Col lg={6} sm={8} className="img-col-hero" >
                                <div className="home-img mt-5 mt-lg-0">
                                    <img src={homeImg} alt="" className="img-fluid mx-auto d-block" />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </React.Fragment>
        );
    }
}

export default Section;